import { observable, action } from "mobx";
import { Configuracao } from "../../../services";
import * as Mensagens from "../../../utils/MensagemUtil";
import { validarCamposObrigatorios } from "../../../utils/Validate";
import * as util from "../../../utils/MascaraUtil";

class QuadroComposicaoTaxaBDIStore {
  @observable
  quadro = {
    id: null,
    custoTributarioMaterialId: "",
    percentualCustoAdministracaoCentral: "",
    percentualCustoSeguroGarantia: "",
    percentualCustoMargemIncertezaEmpreendimento: "",
    percentualCustoFinanceiro: "",
    percentualCustoTotalTributarios: "",
    percentualMargemContribuicaoBruta: "",
    percentualArrecadacoesFe: "",
    percentualTotalTaxaBDI: "",
    custoTributarioMaterial: {
      percentualPis: "",
      percentualCofins: "",
      percentualInss: "",
      percentualIss: "",
      percentualFe: ""
    }
  };

  @observable
  fetching = false;

  @action.bound
  async obterQuadro() {
    try {
      this.fetching = true;

      const result = await Configuracao.obterQuadro();
      if (result && result.erro) {
        return Mensagens.error(result.erro);
      }

      this.quadro = result;

      this.calcularTotais();
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  async salvar() {
    try {
      this.fetching = true;

      const erros = this.validarQuadroComposicaoTaxaBDI(this.quadro);
      if (erros.length > 0) {
        Mensagens.error(erros);
        return;
      }

      this.quadro = {
        id: this.quadro.id,
        custoTributarioMaterialId: this.quadro.custoTributarioMaterialId,
        percentualCustoAdministracaoCentral: util.remover(this.quadro.percentualCustoAdministracaoCentral),
        percentualCustoSeguroGarantia: util.remover(this.quadro.percentualCustoSeguroGarantia),
        percentualCustoMargemIncertezaEmpreendimento: util.remover(this.quadro.percentualCustoMargemIncertezaEmpreendimento),
        percentualCustoFinanceiro: util.remover(this.quadro.percentualCustoFinanceiro),
        percentualCustoTotalTributarios: util.remover(this.quadro.percentualCustoTotalTributarios),
        percentualMargemContribuicaoBruta: util.remover(this.quadro.percentualMargemContribuicaoBruta),
        percentualArrecadacoesFe: util.remover(this.quadro.percentualArrecadacoesFe),
        percentualTotalTaxaBDI: util.remover(this.quadro.percentualTotalTaxaBDI),
        custoTributarioMaterial: {
          percentualPis: util.remover(this.quadro.custoTributarioMaterial.percentualPis),
          percentualCofins: util.remover(this.quadro.custoTributarioMaterial.percentualCofins),
          percentualInss: util.remover(this.quadro.custoTributarioMaterial.percentualInss),
          percentualIss: util.remover(this.quadro.custoTributarioMaterial.percentualIss),
          percentualFe: util.remover(this.quadro.custoTributarioMaterial.percentualFe)
        }
      };

      const quadro = await Configuracao.atualizarQuadro(this.quadro);

      if (quadro.erro) {
        return Mensagens.error(quadro.erro);
      }

      Mensagens.success("Quadro atualizado com sucesso!");
    } finally {
      this.fetching = false;
    }
  }

  validarQuadroComposicaoTaxaBDI = registro => {
    const erros = validarCamposObrigatorios()
      .addSeNuloOuVazio("Custo de Administração Central - AC", registro.percentualCustoAdministracaoCentral)
      .addSeNuloOuVazio("Custo de Seguro e Garantia", registro.percentualCustoSeguroGarantia)
      .addSeNuloOuVazio("Custo de Margem de Incerteza do Empreendimento - MI", registro.percentualCustoMargemIncertezaEmpreendimento)
      .addSeNuloOuVazio("Custo Financeiro - CF", registro.percentualCustoFinanceiro)
      .addSeNuloOuVazio("Custos Tributários - Total - T", registro.percentualCustoTotalTributarios)
      .addSeNuloOuVazio("Margem de Contribuição Bruta(Benefício ou Lucro) - MC", registro.percentualMargemContribuicaoBruta)
      .addSeNuloOuVazio("Arrecadações - FE", registro.percentualArrecadacoesFe)
      .addSeNuloOuVazio("TAXA DE BDI(BDI)", registro.percentualTotalTaxaBDI)
      .build();

    return erros;
  };

  @action.bound
  calcularTotais() {
    const subTotalCustosTributarios =
      this.quadro.custoTributarioMaterial.percentualInss +
      this.quadro.custoTributarioMaterial.percentualCofins +
      this.quadro.custoTributarioMaterial.percentualPis;

    const totalCustosTributarios = this.quadro.custoTributarioMaterial.percentualIss + subTotalCustosTributarios;
    const totalGeralCustosTributarios = totalCustosTributarios + this.quadro.custoTributarioMaterial.percentualFe;

    const percentualTotalTaxaBDI =
      (((1 +
        this.quadro.percentualCustoAdministracaoCentral / 100 +
        this.quadro.percentualCustoSeguroGarantia / 100 +
        this.quadro.percentualCustoMargemIncertezaEmpreendimento / 100) *
        (1 + this.quadro.percentualCustoFinanceiro / 100) *
        (1 + this.quadro.percentualMargemContribuicaoBruta / 100)) /
        (1 - this.quadro.percentualCustoTotalTributarios / 100) -
        1) *
      100;

    this.quadro.percentualTotalTaxaBDI = util.percentual(percentualTotalTaxaBDI);
    this.quadro.subTotalCustosTributarios = util.percentual(subTotalCustosTributarios);
    this.quadro.totalCustosTributarios = util.percentual(totalCustosTributarios);
    this.quadro.custosTributariosFederais = util.percentual(subTotalCustosTributarios);
    this.quadro.totalGeralCustosTributarios = util.percentual(totalGeralCustosTributarios);
    this.quadro.custosTributariosEstaduais = util.percentual(0);
    this.quadro.custosTributariosMunicipais = util.percentual(this.quadro.custoTributarioMaterial.percentualIss);
  }

  @action.bound
  handleChange = ({ target }) => {
    const { name, value } = target;

    this.quadro[name] = value;
  };

  @action.bound
  handleBlur = ({ target }) => {
    const { name, value } = target;
    const valor = util.remover(value);

    this.quadro[name] = valor;

    this.calcularTotais();
  };
}

export default new QuadroComposicaoTaxaBDIStore();



// WEBPACK FOOTER //
// ./src/views/configuracoes/stores/QuadroComposicaoTaxaBDIStore.js